import App from 'app/app.js';

function LtStepperProgressCtrl($scope, ProgressStepperStore) {
  this.progressStatus = ProgressStepperStore.getStatus();

  this.isActive = function (page) {
    return $scope.currentPage === page;
  };
}

App.controller('LtStepperProgressCtrl', ['$scope', 'ProgressStepperStore', LtStepperProgressCtrl]);
